import { LoadingIndicator } from 'common/components/common/style';
import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';

GlobalStyle.inject`
  .debug-view {
    position: absolute;
    min-width: ${getScalablePixel(300)}px;
    max-width: 90%;
    max-height: 90%;
    bottom: ${getScalablePixel(70)}px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: ${getScalablePixel(16)}px;
    padding: ${getScalablePixel(16)}px ${getScalablePixel(32)}px;
    background-color: ${variables.color_grey_80};
    z-index: 1000;
    pointer-events: none;
    opacity: 0.6;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: ${variables.color_grey_10};
    text-align: center;

    h3 {
        margin: 0;
    }


    .debug-line {
        display: flex;
        flex-direction: row;
        flex: 1;
        align-items: center;
        justify-content: space-between;
        margin: ${getScalablePixel(8)}px 0;
        gap: ${getScalablePixel(16)}px;

        .status {
            font-size: ${getScalablePixel(20)}px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .icon {
                margin-left: ${getScalablePixel(8)}px;
            }

            ${LoadingIndicator} {
                margin-left: ${getScalablePixel(8)}px;
                width: ${getScalablePixel(20)}px !important;
                height: ${getScalablePixel(20)}px !important;
                border-width: ${getScalablePixel(2)}px !important;
                position: relative;
            }


            &.success {
                color: #27CD41;
            }

            &.fail {
                color: #C93400;
            }

            &.pending {
                color: #717171;
            }
        }
    }
  }
`;
